import { Box, FormLabel } from "@mui/material";
import TooltipPopover from "../../../../components/shared/others/TooltipPopover";

const TooltipTotalCharged = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center'}}>
            <TooltipPopover>
                Quantia que deve ser paga pelo <br/> 
                cliente. <br/>
                <br />
                É a somatória do valor de todos os <br/> 
                itens adicionados para cobrança <br/> 
                durante a criação da fatura.
            </TooltipPopover>
        </Box>
    )
}

export default TooltipTotalCharged;